module.exports = __webpack_public_path__ + "static/media/drapcode-logo-bluegreen.6dfc8634.png";